var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4099 42.5036C23.6977 42.7976 24.0897 42.9609 24.5001 42.9609C24.9105 42.9609 25.3025 42.7976 25.5904 42.5036L45.1781 22.6566C53.3468 14.3817 47.5424 0.0859375 35.9253 0.0859375C28.9489 0.0859375 25.7476 5.21256 24.5001 6.1701C23.2465 5.20848 20.0656 0.0859375 13.0749 0.0859375C1.49462 0.0859375 -4.3813 14.3449 3.82416 22.6566L23.4099 42.5036Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.d254e57dfadecee49b49db4529fe8855.svg";
export { ForwardRef as ReactComponent };